<template>
  <base-layout showSettings="true">
    <ion-grid>
      <ion-row>
        <ion-col size-sm="8" offset-sm="2" size="12">
          <ion-img class="login_logo" :src="logo" />
        </ion-col>
      </ion-row>      
      <ion-row>
        <ion-col size-sm="8" offset-sm="2" size="12">
          <ion-item lines="none">
            <ion-label position="stacked">Username</ion-label>
            <ion-input
              type="text"
              id="username"
              name="username"
              v-model="username"
            />
          </ion-item>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size-sm="8" offset-sm="2" size="12">
          <ion-item lines="none">
            <ion-label position="stacked">Password</ion-label>
            <ion-input
              type="password"
              id="password"
              name="password"
              v-model="password"
            />
          </ion-item>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col size-sm="8" offset-sm="2" size="12" class="ion-text-center ion-margin-top">
          <div class="form-buttons">
            <ion-button id="submit" @click="login" size="small" color="success" >Login</ion-button>
          </div>
          <div v-if="error!==''" class="login_error ion-text-center">{{ error }}</div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </base-layout>
</template>

<script>
import {
  IonGrid,
  IonRow,
  IonCol,
  IonItem,
  IonInput,
  IonButton,
} from "@ionic/vue";

export default {
  name: "Home",
  components: {
    IonGrid,
    IonRow,
    IonCol,
    IonItem,
    IonInput,
    IonButton,
  },

  data() {
    return {
      logo: "",
      username: "",
      password: "",
      error: "",
    };
  },

  mounted() {
    if (process.env.VUE_APP_CUSTOMER == "jiunho") {
      this.logo = require("@/theme/jiunho.png");
    } else if (process.env.VUE_APP_CUSTOMER == "sandrajordan") {
      this.logo = require("@/theme/sandrajordan.png");
    } else if (process.env.VUE_APP_CUSTOMER == "leondemo") {
      this.logo = require("@/theme/leondemo.png");
    }
  },

  methods: {
    async login() {
      const actionPayload = {
        username: this.username,
        password: this.password,
      };

      try {
        await this.$store.dispatch("login", actionPayload);
        this.$router.replace("/home");
      } catch (err) {
        this.error = err.message || "Failed to authenticate, try later.";
      }
    },
  },
};
</script>

<style scoped>
ion-item {
  --padding-start: 0;
  --background-focused: transparent;
  --min-height: 65px;
}

ion-label {
  margin-top: 10px !important;
  margin-bottom: 10px !important;
  font-size: 14px !important;
}

ion-input {
  border: 1px solid #cbcbcb;
  border-radius: 3px;
  font-size: 14px;
  --padding-start: 10px !important;
  --padding-top: 10px !important;
  --padding-bottom: 10px !important;
}

ion-row {
  margin-bottom: 5px;
  height: auto;
}

ion-grid {
  padding: 2em;
}

ion-col {
  --ion-grid-column-padding: 0 5px;
}

ion-list-header ion-label {
  margin-top: 16px;
}

ion-button {
  border-radius: 0;
  height: 40px;
  width: 100px;
  color: #404040;
  --background: #ffffff;
}

.login_error {
  color: red;
  font-size: 15px;
}

.login_logo {
  height:30vh;
  max-width:100%;  
}

</style>